import { render } from "./AlignOther.vue?vue&type=template&id=07fde8ee"
import script from "./AlignOther.vue?vue&type=script&lang=js"
export * from "./AlignOther.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/PROD/okr-web-next/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__